import React, { useEffect, useState } from 'react';
import QuotationComparisonTable from './DataTables/QuotationComparisonTable';
import api from './Axios/api';
import Loader from "./common/Loader";
import { useNavigate } from 'react-router-dom';
const QuoteComparison = () => {
    const [data, setData] = useState([]);
    const [month, setMonth] = useState("");
    const [isloading, setIsLoading] = useState(false);
      const navigate = useNavigate();

    const quotations = async () => {
        try {
             setIsLoading(true);
            const response = await api.get(`/purchase/get-quotation-comparison-list?month=${month}`);
            const sortedDesc = response.data.sort((a,b) => new Date(b.indent_date) - new Date (a.indent_date));
            setData(sortedDesc);
            // console.log("api",response.data)
            setIsLoading(false);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        quotations();
    }, [month])
      useEffect(() => {
        const now = new Date();
        const year = now.getFullYear();
        const monthNum = String(now.getMonth() + 1).padStart(2, "0");
        const currentMonth = `${year}-${monthNum}`;
        setMonth(currentMonth);
      }, []);

    return (
        <div className='px-5 flex flex-col items-center'>
            <div className="w-full flex flex-col md:flex-row md:items-center justify-between px-4 py-2 bg-[#fdfdfd] shadow rounded-md my-4 text-violet-500 font-bold">
                <div className="text-lg">  Quotation Comparison List </div>
                  <div className="mb-2 md:mb-0">
                <input
                    type="month" value={month}
                onChange={(e) => {
                  setMonth(e.target.value)}}
           
                    className="border rounded px-2 py-1 w-full md:w-auto"
                />        
            </div>
                <div onClick={()=>navigate('/quote-comparison-history')} className='text-white font-bold rounded-md px-3 bg-violet-600 hover:bg-violet-700 hover:ease-in shadow border flex items-center cursor-pointer transition-colors'>
                     History 
                </div>
            </div>
             
            <div className='w-full min-h-[500px] rounded-md shadow bg-[#fdfdfd] '>
               {  isloading ? ( <Loader/>):(
                 <QuotationComparisonTable data={data} />
                  )} 
            </div>  
        </div>
    )
}

export default QuoteComparison;